import { SourceBalanceStoreModel } from "../../../../models/store/source-balance.store.model";
import { ParserAbstraction } from "@bitwarden/web-vault/app/services/dali/vault-parser/parser/parser.abstraction";
import { ParserFunctionType } from "../parser.type";

export class SourceBalanceParser extends ParserAbstraction {
  override getParser(version: number): ParserFunctionType {
    if (!this.isSupportedVersion(version)) {
      throw new Error(`Unsupported SourceBalance parser version ${version}`);
    }
    return SourceBalanceParser_v1;
  }

  override getSupportedVersion(): number[] {
    return [1];
  }
}

const SourceBalanceParser_v1 = (model: unknown): SourceBalanceStoreModel =>
  model as SourceBalanceStoreModel;
